import { useState } from 'react';
import {
  SectionLayout,
  SectionLayoutSkeleton,
} from '@/components/ui/SectionLayout.tsx';
import {
  SettingsList,
  SettingsListRow,
} from '@/components/ui/SettingsList.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import StatusDot from '@/components/ui/StatusDot.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useGetPaymentProviderStatus from '@/features/dashboard/paymentProviders/hooks/useGetPaymentProviderStatus.ts';
import RegisterTpayModal from '@/features/dashboard/paymentConfig/components/RegisterTpayModal.tsx';
import { PaymentProviderType } from '@/features/dashboard/paymentProviders/types/PaymentProviderType.ts';
import { TpayVerificationStatus } from '@/features/dashboard/paymentProviders/types/TpayVerificationStatus.ts';
import {
  getTpayVerificationStatusLabel,
  tpayVerificationStatusTones,
} from '@/features/dashboard/paymentProviders/types/TpayVerificationStatus.utils.ts';

const TpaySection = () => {
  const { data: statuses, isLoading } = useGetPaymentProviderStatus();
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  if (isLoading) {
    return <SectionLayoutSkeleton rows={1} />;
  }

  const tpay = statuses?.find((s) => s.provider === PaymentProviderType.TPAY);
  const verificationStatus =
    tpay?.verificationStatus ?? TpayVerificationStatus.UNKNOWN;
  const isRegistered = tpay?.configured ?? false;

  return (
    <>
      <SectionLayout
        title="Płatności online"
        description="Bramka TPay pozwala uczestnikom płacić kartą i BLIK-iem przy zapisie. Rozliczenia i weryfikację prowadzi TPay."
      >
        {isRegistered ? (
          <SettingsList>
            <SettingsListRow
              title="TPay"
              status={
                <StatusDot
                  tone={tpayVerificationStatusTones[verificationStatus]}
                  label={getTpayVerificationStatusLabel(verificationStatus)}
                  className="text-[12.5px]"
                />
              }
              subtitle={
                tpay?.registeredEmail && (
                  // Adres nie ma spacji, więc bez `break-all` rozpycha wiersz na telefonie.
                  <span className="break-all">{tpay.registeredEmail}</span>
                )
              }
            />
          </SettingsList>
        ) : (
          <NoItems
            title="Płatności online nie są skonfigurowane"
            description="Zarejestruj konto TPay, aby uczestnicy mogli płacić od razu po zapisie."
          >
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsRegisterOpen(true)}
            >
              Zarejestruj konto TPay
            </ActionButton>
          </NoItems>
        )}
      </SectionLayout>

      {isRegisterOpen && (
        <RegisterTpayModal onClose={() => setIsRegisterOpen(false)} />
      )}
    </>
  );
};

export default TpaySection;
